class TagManager {
  constructor() {
    this.gtmOrderData = {};
  }

  pushEvent(event, params = {}) {
    window.dataLayer = window.dataLayer || [];

    const item = {
      event,
      data: {
        ...params,
      },
    };

    window.dataLayer.push(item);
  }

  pushEcommerceEvent(event, params = {}) {
    window.dataLayer = window.dataLayer || [];

    const item = {
      event,
      ecommerce: {
        ...this.gtmOrderData,
        ...params,
      },
    };

    window.dataLayer.push(item);
    window.internalLayer.push(item);
  }
}

export default new TagManager();
